import { IBaseBatchResponse } from "./BatchConsults";

export interface IDebtTotalPrice{
  cod: number; // Debt consult number
  price: number; // Debt Total Price
}

export interface ICreateBatchInstallmentsRequest {
  consults: IDebtTotalPrice[]
}

export interface IInstallment {
  tipo: string,
  parcelas: number,
  cet: number,
  valor: number,
  total: number,
  desconto: number
}

export interface ICreateBatchInstallmentsResponse extends IBaseBatchResponse {
  cupom: string,
  cupomAplicado: boolean,
  valor: number,
  mostraCET: boolean,
  parcelas: IInstallment[]
}

export const isCreateBatchInstallmentsResponse = (data: any): data is ICreateBatchInstallmentsResponse => {
  return data && typeof data.sucesso === 'boolean' && 'parcelas' in data;
};

